import { useState } from 'react';
import useFormValidation from '../../../../../hooks/useFormValidation';
import useEmployeeQuantityFieldsConfig from './useEmployeeQuantityFieldsConfig';
import { useTranslation } from 'react-i18next';

export interface EmployeeQuantityFormData {
    ownAdministrativeWorkers: string | null;
    ownProductionWorkers: string | null;
    eventualAdministrativeWorkers: string | null;
    eventualProductionWorkers: string | null;
}

const INITIAL_VALUES = {
    ownAdministrativeWorkers: '',
    ownProductionWorkers: '',
    eventualAdministrativeWorkers: '',
    eventualProductionWorkers: ''
};

const getInitialData = (initialEstablishmentData: any) => {
    if (!initialEstablishmentData) return INITIAL_VALUES;
    return {
        ownAdministrativeWorkers: initialEstablishmentData?.propiosAdministrativos || '',
        ownProductionWorkers: initialEstablishmentData?.propiosProduccion || '',
        eventualAdministrativeWorkers: initialEstablishmentData?.eventualesAdministrativos || '',
        eventualProductionWorkers: initialEstablishmentData?.eventualesProduccion || ''
    };
};

const useEmployeeQuantityForm = (carcinogenicReportData: any) => {
    const initialData = getInitialData(carcinogenicReportData?.establecimiento);
    const [initialFormValues] = useState(initialData);
    const [formData, setFormData] = useState(initialData);

    const { t } = useTranslation('carcinogenicReport', { keyPrefix: 'modules.establishmentData' });

    const {
        errors,
        hasValidationErrors,
        validateForm,
        handleBlurValidation,
        resetValidation,
        setErrors
    } = useFormValidation();

    const { employeeQuantityFieldsConfig } = useEmployeeQuantityFieldsConfig({
        t,
        employeeQuantityFormData: formData,
        handleBlurValidation
    });

    const handleChange = (name: string, value: any) => {
        setErrors((prevState) => ({
            ...prevState,
            [name]: { hasError: false, errorMessage: '' }
        }));
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const hasFormDataChanged =
        formData.ownAdministrativeWorkers !== initialFormValues.ownAdministrativeWorkers ||
        formData.ownProductionWorkers !== initialFormValues.ownProductionWorkers ||
        formData.eventualAdministrativeWorkers !==
            initialFormValues.eventualAdministrativeWorkers ||
        formData.eventualProductionWorkers !== initialFormValues.eventualProductionWorkers;

    return {
        formData,
        errors,
        employeeQuantityFieldsConfig,
        handleChange,
        validateForm,
        hasFormDataChanged
    };
};

export default useEmployeeQuantityForm;
